import { render, staticRenderFns } from "./address-comp.vue?vue&type=template&id=ae608e5e&"
import script from "./address-comp.vue?vue&type=script&lang=js&"
export * from "./address-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports